module.exports = __webpack_public_path__ + "static/media/cap.f4daec47.png";